import { Box, Typography } from '@mui/material';
import { memo } from 'react';
import { GOOGLE_ACCOUNT_SETTING } from './constant';
import * as Styled from './styles';

export const GoogleChangePassword = memo(() => {
  return (
    <Box>
      <Typography variant="body4">
        It looks like you signed up using Google authentication. To change your
        password, please visit your Google Account settings directly.
      </Typography>
      <Typography variant="body4">
        As your account access is managed through Google, any password changes
        need to be made within your Google Account to ensure your security and
        access continuity across all services using Google sign-in.
      </Typography>
      <Styled.GoogleSetting href={GOOGLE_ACCOUNT_SETTING}>
        Go to Google Account Settings
      </Styled.GoogleSetting>
      <Typography variant="body4">
        Thank you for ensuring the security of your account
      </Typography>
    </Box>
  );
});

GoogleChangePassword.displayName = 'GoogleChangePassword';
